export class CUSTOMREPORTS_GROUP {

  ReportID: number;
  ReportName: string;
  CriteriaID: number;
  CriteriaName: string;
  EachCriteria: string;
  GraphApply: string;
  HideCol: string;
  GroupByColName: string;
  DefaultOrNot: number;
  CriteriaList: any[];

  constructor() {
    this.ReportID = 0;
    this.ReportName = "";
    this.CriteriaID= 0;
    this.CriteriaName = "";
    this.EachCriteria = "";
    this.GraphApply = "False";
    this.HideCol = "";
    this.GroupByColName = "";
  }
}
